import styled from 'styled-components'

import { font, color } from '~/styles/utils'

export const Container = styled.div`
  margin-bottom: 20px;
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
`

export const Name = styled.div`
  font-size: 18px;
  ${font('bold')};
  color: ${color('black')};
`

export const CreditsRemaining = styled.div`
  font-size: 14px;
  color: ${color('black')};
`
